module.exports = __webpack_public_path__ + "img/step4.9d4fe535.svg";